// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_react-draft-wysiwyg_dist_react-draft-wysiwyg_css":"c94ccd1866209f094f46","src_bootstrap_js-src_app_css":"c131219821261ab4ea62","vendors-node_modules_object-assign_index_js-node_modules_saas-ui-design_dist_index_js":"5b70165e90618fcf8ea4"}[chunkId] + ".css";
};